module.exports = __webpack_public_path__ + "static/social-banner-5b5d0280654f7aa14c955319b865af9e.jpg";